import { ResponseData, Err } from 'types';

import { RESTRICTED_COUNTRY_ID } from 'consts';

import { http } from '.';

export const sendFinishEmail = async (payload) => {
  return await http.post<Err, ResponseData<any>>(
    `/Invoices/EmailInvoice`,
    payload
  );
};

export const getBusinessTypes = async () => {
  return await http.get<Err, ResponseData<any>>(`/BusinessTypes`);
};

export const getCountries = async () => {
  const response = await http.get<Err, ResponseData<any>>(`/countries`);

  return {
    ...response,
    data: {
      ...response.data,
      data: response.data.data.filter(
        (country) => country.id !== RESTRICTED_COUNTRY_ID
      ),
    },
  };
};

export const getLegalDocTypes = async (businessTypeId) => {
  return await http.get<Err, ResponseData<any>>(
    `/LegalDocTypes?businessType=${businessTypeId}`
  );
};

export const getDocTypes = async (language: string) => {
  return await http.get<Err, ResponseData<any>>(`/DocumentType/${language}`);
};

export const getCurrencies = async () => {
  return await http.get<Err, ResponseData<any>>(`/Currencies/GetCurrencies`);
};

export const getLanguages = async () => {
  return await http.get<Err, ResponseData<any>>(`/Invoices/GetInvoiceLanguage`);
};

export const setLanguage = async (language: string) => {
  return await http.post<Err, ResponseData<any>>(
    `/Accounts/SetInvoiceDefaultLanguage/${language}`
  );
};

export const getTaxTypes = async () => {
  return await http.get<Err, ResponseData<any>>(`/TaxTypes/`);
};

export const updateTaxType = async (taxType) => {
  return await http.put<Err, ResponseData<any>>(`/TaxTypes/`, taxType);
};

export const createTaxType = async (taxType) => {
  return await http.post<Err, ResponseData<any>>(`/TaxTypes/`, taxType);
};
export const deleteTaxType = async (id: number) => {
  return await http.delete<Err, ResponseData<boolean>>(`TaxTypes/${id}`);
};

export const updateMeasurementUnit = async (measurementUnit) => {
  return await http.put<Err, ResponseData<any>>(
    `/MeasurementUnits/`,
    measurementUnit
  );
};

export const createMeasurementUnit = async (measurementUnit) => {
  return await http.post<Err, ResponseData<any>>(
    `/MeasurementUnits/`,
    measurementUnit
  );
};

export const getMeasurementUnits = async () => {
  return await http.get<Err, ResponseData<any>>(`/MeasurementUnits/`);
};
export const deleteMeasurementUnits = async (id: number) => {
  return await http.delete<Err, ResponseData<boolean>>(
    `MeasurementUnits/${id}`
  );
};

export const getSalesTypes = async () => {
  return await http.get<Err, ResponseData<any>>(`/SalesTypes/`);
};

export const updateSalesType = async (salesType) => {
  return await http.put<Err, ResponseData<any>>(`/SalesTypes/`, salesType);
};
export const deleteSalesType = async (id: number) => {
  return await http.delete<Err, ResponseData<boolean>>(`SalesTypes/${id}`);
};

export const createSalesType = async (salesType) => {
  return await http.post<Err, ResponseData<any>>(`/SalesTypes/`, salesType);
};

export const getPaymentMethods = async () => {
  return await http.get<Err, ResponseData<any[]>>(`/PaymentMethod/`);
};

export const updatePaymentMethod = async (paymentMethod) => {
  return await http.put<Err, ResponseData<any>>(
    `/PaymentMethod/`,
    paymentMethod
  );
};

export const createPaymentMethod = async (paymentMethod) => {
  return await http.post<Err, ResponseData<any>>(
    `/PaymentMethod/`,
    paymentMethod
  );
};

export const deletePaymentMethod = async (paymentMethodsId: number) => {
  return await http.delete<Err, ResponseData<boolean>>(
    `PaymentMethod/${paymentMethodsId}`
  );
};
